<template>
	<div class="d-flex justify-content-between flex-wrap p-2 ml-2 mr-2">
		<!-- page length -->
		<div class="d-flex align-items-center mb-0 mt-1">
			<span class="text-nowrap"> Showing 1 to </span>
			<b-form-select
				v-model="pageLength"
				:options="pageOptions"
				class="mx-1"
				@input="onPerPageChange"
				size="sm"
			/>
			<span class="text-nowrap"> of entries </span>
		</div>

		<div>
			<b-pagination
				:value="page"
				:total-rows="total"
				:per-page="pageLength"
				first-number
				last-number
				align="right"
				prev-class="prev-item"
				next-class="next-item"
				class="mt-1 mb-0"
				@change="onPageChange"
			>
				<template #prev-text>
					<i class="fa fa-angle-left"></i>
				</template>
				<template #next-text>
					<i class="fa fa-angle-right"></i>
				</template>
			</b-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			page: 1,
			pageLength: 20,
			pageOptions: ["10", "20", "50", "100"],
		};
	},
	props: {
		pageChanged: {
			type: Function,
		},
		perPageChanged: {
			type: Function,
		},
		total: {
			type: Number,
		}
	},
	methods: {
		onPerPageChange(perPage) {
         console.log(perPage)
			this.perPageChanged({ currentPerPage: perPage });
         this.$emit('update:perpage', perPage);
		},
		onPageChange(page) {
         console.log(page)
         this.pageChanged({ currentPage: page });
			this.$emit('update:page', page)
		},
	},
};
</script>
